export const NEW_ROUTE = 'NEW_ROUTE';

export function newRoute(url, view) {
  return { type: NEW_ROUTE, url, view };
}
